import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class ViewTransitionService {
  run(stateChangeFn: () => void) {
    if (!document.startViewTransition) {
      stateChangeFn();
      return;
    }

    document.startViewTransition(async () => {
      stateChangeFn();

      // await createRenderPromise(); // <-- TODO
    });
  }
}
